import type { AdminTagsStreamEvent } from '@interfaces/IAdminTag';
import { SseChannel, siteStreamUrl, type ISseChannelHandlers } from './sseChannel';

// Browser-side client for the `/api/sites/:siteId/admin/tags/stream` SSE
// channel. All of the connection machinery — reconnect backoff, heartbeat
// watchdog, visibility-based close — lives in `SseChannel`; this only binds it
// to the tags path and event type.

export type AdminTagsStreamHandlers = ISseChannelHandlers<AdminTagsStreamEvent>;

export class AdminTagsStream {
  private readonly channel: SseChannel<AdminTagsStreamEvent>;

  constructor(siteId: string, handlers: AdminTagsStreamHandlers) {
    this.channel = new SseChannel(siteStreamUrl(siteId, 'admin/tags/stream'), handlers);
  }

  open(): void {
    this.channel.open();
  }

  close(): void {
    this.channel.close();
  }
}
